"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.economyTransactionTypesOptions = exports.ECONOMY_TRANSACTION_TYPES = exports.challengeTransactionStatusesOptions = exports.CHALLENGE_TRANSACTION_STATUSES = void 0;
var CHALLENGE_TRANSACTION_STATUSES = ["Active", "Completed", "Failed", "Expired"];
exports.CHALLENGE_TRANSACTION_STATUSES = CHALLENGE_TRANSACTION_STATUSES;
var ECONOMY_TRANSACTION_TYPES = ["Cashback", "Earn", "Earning Event", "Spending", "XP Points"];
exports.ECONOMY_TRANSACTION_TYPES = ECONOMY_TRANSACTION_TYPES;
var challengeTransactionStatusesOptions = CHALLENGE_TRANSACTION_STATUSES.map(function (status) { return ({
    label: status,
    value: status,
}); });
exports.challengeTransactionStatusesOptions = challengeTransactionStatusesOptions;
var economyTransactionTypesOptions = ECONOMY_TRANSACTION_TYPES.map(function (type) { return ({
    label: type,
    value: type,
}); });
exports.economyTransactionTypesOptions = economyTransactionTypesOptions;
